var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.66537L11.6667 1.33203C11 0.665365 10 0.665365 9.33333 1.33203C8.66667 1.9987 8.66667 2.9987 9.33333 3.66536L14.8333 9.16537H2.16667C1.16667 9.16537 0.5 9.83203 0.5 10.832C0.5 11.832 1.16667 12.4987 2.16667 12.4987H14.8333L9.33333 17.9987C8.66667 18.6654 8.66667 19.6654 9.33333 20.332C10 20.9987 11 20.9987 11.6667 20.332L20 11.9987C20.6667 11.4987 20.6667 10.332 20 9.66537Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.b82a852d43e39a3bb3e57ad34172b7cb.svg";
export { ForwardRef as ReactComponent };